import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class GeoPosition extends BaseModel {
  static override constructorName = 'GeoPosition'

  public text: string = ''
  public name: string = ''
  public phone: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}
